import { getStoreAccessors } from 'vuex-typescript';
import { GLOBAL, ADDRESS_API } from '@/constant';
import { ActionContext } from 'vuex';
import { axios } from '@zyf2e/adapt';


setTimeout(() => {
  console.log('axios.axios');
  console.log(axios.axios);
})


interface IgState {
  keepAliveList: string[];
  location?: string;
}

export const globalPersistField = ['keepAliveList', 'location'];
type Context = ActionContext<IgState, {}>;

const global = {
  namespaced: true,
  state: {
    keepAliveList: ['Home', 'GroupDoctorList', 'DoctorSearch'],
    location: ''
  },
  actions: {
    async getLocation(context: Context, { latitude, longitude }: Partial<Coordinates>): Promise<string> {
      const { city } = await axios.get(ADDRESS_API.GET_LOCATION, {
        params: { location: [latitude, longitude].join(',') }
      });
      return city;
    }
  },
  mutations: {
    setKeepAliveList(state: IgState, moudelName: string) {
      state.keepAliveList.push(moudelName);
      Object.assign(state, {
        keepAliveList: [...new Set(state.keepAliveList)]
      });
    },
    removeKeepAliveList(state: IgState, moudelName: string) {
      Object.assign(state, {
        keepAliveList: state.keepAliveList.filter(el => el !== moudelName)
      });
    },
    setLocation(state: IgState, city: string) {
      state.location = city || '';
    }
  }
};

const { commit, dispatch } = getStoreAccessors<IgState, {}>(GLOBAL);
const { mutations, actions } = global;
const { setKeepAliveList, removeKeepAliveList, setLocation } = mutations;
const { getLocation } = actions;

export const commitSetKeepAliveList = commit(setKeepAliveList);

export const commitRemoveKeepAliveItem = commit(removeKeepAliveList);

export const commitSetLocation = commit(setLocation);

export const dispatchGetLocation = dispatch(getLocation);

export default global;
